import React from 'react';
import CustomTextField from './CustomFields/CustomTextField';
import CustomTextArea from './CustomFields/CustomTextArea';
import SocialPanel from './CustomFields/SocialPanel';
import CustomPhoneInput from './CustomFields/CustomPhoneInput';
import CustomPanelForm from './CustomFields/CustomPanelForm';
import CustomSatelliteNumberField from './CustomFields/CustomSatelliteNumberField';


const RenderAccordionField = ({
  field,
  index,
  handleFieldChange,
  handleClearField,
  handleDeleteField,
  shudClearBtnRender,
  shudDeleteBtnRender,
  componentType,
}) => {
  switch (componentType) {
    case 'aboutMe':
      return (
        <CustomTextArea
          key={index}
          field={field}
          index={index}
          onChange={handleFieldChange}
          onClear={handleClearField}
          onDelete={handleDeleteField}
          shudClearBtnRender={shudClearBtnRender}
          shudDeleteBtnRender={shudDeleteBtnRender}
        />
      );
    case 'emailAddress':
      return (
        <CustomTextField
          key={field.id}
          field={field}
          index={index}
          handleFieldChange={handleFieldChange}
          handleClearField={handleClearField}
          handleDeleteField={handleDeleteField}
          shudClearBtnRender={shudClearBtnRender}
          shudDeleteBtnRender={shudDeleteBtnRender}
        />
      );
    case 'satellite':
      return (
        <CustomSatelliteNumberField
          key={field.id}
          field={field}
          index={index}
          handleFieldChange={handleFieldChange}
          handleClearField={handleClearField}
          handleDeleteField={handleDeleteField}
          shudClearBtnRender={shudClearBtnRender}
          shudDeleteBtnRender={shudDeleteBtnRender}
        />
      );
    case 'media':
      return (
        <SocialPanel
          key={field.id}
          field={field}
          index={index}
          handleFieldChange={handleFieldChange}
          handleClearField={handleClearField}
          handleDeleteField={handleDeleteField}
          shudClearBtnRender={shudClearBtnRender}
          shudDeleteBtnRender={shudDeleteBtnRender}
        />
      );
    case 'phone':
    case 'land':
    case 'mobile':
      return (
        <CustomPhoneInput
          key={field.id}
          field={field}
          index={index}
          onChange={handleFieldChange}
          onClear={handleClearField}
          onDelete={handleDeleteField}
          shudClearBtnRender={shudClearBtnRender}
          shudDeleteBtnRender={shudDeleteBtnRender}
        />
      );
    case 'form':
      return <CustomPanelForm
        key={field.id}
        field={field}
        index={index}
        handleFieldChange={handleFieldChange}
        handleClearField={handleClearField}
        shudClearBtnRender={shudClearBtnRender}
        shudDeleteBtnRender={shudDeleteBtnRender}
      />
    default:
      return null;
  }
};

export default RenderAccordionField;
